export default __webpack_public_path__ + "d4ad6014718c78fb2c12b05524074a94.png";